import './Toolbar.scss';
import { Button } from '../..';
import { Editor, EditorState } from 'draft-js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { KeyCommands, ToolbarButtons } from '../types';
import { faBold, faItalic, faLink, faListOl, faListUl, faUnderline } from '@fortawesome/pro-regular-svg-icons';
import React, { RefObject } from 'react';
import classnames from 'classnames';

interface ToolbarProps {
    editorRef?: RefObject<Editor>;
    buttonRefs?: Record<ToolbarButtons.LINK, RefObject<HTMLDivElement>>;
    editorState: EditorState;
    executeCommand: (command: string) => void;
}
export const Toolbar = (props: ToolbarProps) => {
    const { executeCommand, editorState, buttonRefs } = props;

    const selection = editorState.getSelection();
    const blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
    const currentStyle = editorState.getCurrentInlineStyle();

    return (
        <div className="rain-editor-toolbar">
            <Button
                className={classnames('rain-editor-toolbar-button', currentStyle.has('BOLD') && 'active')}
                onMouseDown={(e) => {
                    e.preventDefault();
                    executeCommand(KeyCommands.ToolbarBold);
                }}
                title="Bold">
                <FontAwesomeIcon icon={faBold} />
            </Button>
            <Button
                className={classnames('rain-editor-toolbar-button', currentStyle.has('ITALIC') && 'active')}
                onMouseDown={(e) => {
                    e.preventDefault();
                    executeCommand(KeyCommands.ToolbarItalic);
                }}
                title="Italic">
                <FontAwesomeIcon icon={faItalic} />
            </Button>
            <Button
                className={classnames('rain-editor-toolbar-button', currentStyle.has('UNDERLINE') && 'active')}
                onMouseDown={(e) => {
                    e.preventDefault();
                    executeCommand(KeyCommands.ToolbarUnderline);
                }}
                title="Underline">
                <FontAwesomeIcon icon={faUnderline} />
            </Button>
            <Button
                className={classnames('rain-editor-toolbar-button', blockType === 'unordered-list-item' && 'active')}
                onMouseDown={(e) => {
                    e.preventDefault();
                    executeCommand(KeyCommands.ToolbarBulletedList);
                }}
                title="Bulleted List">
                <FontAwesomeIcon icon={faListUl} />
            </Button>
            <Button
                className={classnames('rain-editor-toolbar-button', blockType === 'ordered-list-item' && 'active')}
                onMouseDown={(e) => {
                    e.preventDefault();
                    executeCommand(KeyCommands.ToolbarNumberedList);
                }}
                title="Numbered List">
                <FontAwesomeIcon icon={faListOl} />
            </Button>
            <div ref={buttonRefs?.[ToolbarButtons.LINK]}>
                <Button
                    className={classnames('rain-editor-toolbar-button')}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        executeCommand(KeyCommands.ToolbarLink);
                    }}
                    title="Link">
                    <FontAwesomeIcon icon={faLink} />
                </Button>
            </div>
        </div>
    );
};
